import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  clearPageData,
  getPageDescriptionList,
} from "../../../store/Slice/pageDescriptionSlice";

const MoveInMoveOutApp = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const containerRef = useRef(null);

  const { pageDescriptionData, loading } = useSelector(
    (state) => state.pageDescriptionList
  );

  const path = location.pathname.split("/")[1];

  const parts = location.pathname.split("/");
  const slug = parts[parts.length - 1];

  React.useEffect(() => {
    dispatch(clearPageData());
    dispatch(
      getPageDescriptionList({
        vSlug: path === "service-detail" ? slug : path,
        eStatus: "Active",
        eDelete: "No",
      })
    );
  }, [dispatch, path, slug]);

  // const decodedHTML = React.useMemo(() => {
  //   const encoded =
  //     pageDescriptionData?.code === 200 && pageDescriptionData.data;
  //   if (encoded && encoded.length > 0) {
  //     return atob(encoded[0].tDescription || "");
  //   }
  //   return "";
  // }, [pageDescriptionData]);

  const sanitizedHTML = React.useMemo(() => {
    const encoded =
      pageDescriptionData?.code === 200 && pageDescriptionData.data;
    if (encoded && encoded.length > 0) {
      const decoded = atob(encoded[0].tDescription || "");

      // Parse HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(decoded, "text/html");

      // Remove the Book Now button
      const bookNowButton = doc.querySelector(".success-orangebtn");
      if (bookNowButton && path === "service-detail") {
        bookNowButton.remove();
      }

      return doc.body.innerHTML;
    }
    return "";
  }, [pageDescriptionData, path]);

  // React.useEffect(() => {
  //   const handleClick = (event) => {
  //     if (event.target.classList.contains("success-orangebtn")) {
  //       navigate("/book-now");
  //     }
  //   };

  //   // Attach event listener to the document (event delegation)
  //   document.addEventListener("click", handleClick);

  //   return () => {
  //     document.removeEventListener("click", handleClick);
  //   };
  // }, [navigate]);

  if (loading) return null;

  return (
    <>
      {sanitizedHTML ? (
        <div
          id="move-book-now-button"
          ref={containerRef}
          dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
        />
      ) : (
        <div className="col-12">
          <p className="text-center py-2">No Data Found</p>
        </div>
      )}
    </>
  );
};

export default MoveInMoveOutApp;
